import { Component, Input, OnInit } from '@angular/core';
import { GfTitleService } from '../../../../services/core.title.service';

@Component({
    selector: 'project-admin-webhooks-deliveries',
    template: require('./project.admin.webhooks.deliveries.component.html'),
})
export class ProjectAdminWebhooksDeliveriesComponent implements OnInit {
    @Input() project: any;

    constructor(private titleService: GfTitleService) {}

    ngOnInit() {
        this.titleService.setTitle(this.project.name, 'Admin', 'Webhook Delivery Log');
    }
}
